export default "__VITE_ASSET__ByDCCHgp__"